import { useState, useEffect } from 'react'

export const useTheme = () => {
  const [darkMode, setDarkMode] = useState(() => {
    // Verificar se há uma preferência salva no localStorage
    const savedMode = localStorage.getItem('darkMode')
    if (savedMode !== null) {
      return savedMode === 'true'
    }

    // Compatibilidade com chave antiga
    const legacyTheme = localStorage.getItem('theme')
    if (legacyTheme !== null) {
      return legacyTheme === 'dark'
    }

    // Padrão: modo claro
    return false
  })

  // Aplicar o modo salvo no localStorage
  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }, [darkMode])

  // Migração de chave antiga para a chave atual
  useEffect(() => {
    const savedMode = localStorage.getItem('darkMode')
    const legacyTheme = localStorage.getItem('theme')

    if (savedMode === null && legacyTheme !== null) {
      localStorage.setItem('darkMode', (legacyTheme === 'dark').toString())
    }
  }, [])

  const toggleDarkMode = () => {
    const newMode = !darkMode
    setDarkMode(newMode)
    
    // Salvar a preferência no localStorage
    localStorage.setItem('darkMode', newMode.toString())
    
    // Aplicar o modo imediatamente
    if (newMode) {
      document.documentElement.classList.add('dark')
    } else {
      document.documentElement.classList.remove('dark')
    }
  }

  return { darkMode, toggleDarkMode }
}
